import { lazy } from 'react';

export const ConfirmLanguagePage = lazy(() => import('./ConfirmLanguagePage'));
export const OnboardingSurveyPage = lazy(() => import('./OnboardingSurveyPage'));
export const SuccessLanguageChangePage = lazy(() => import('./SuccessLanguageChangePage'));
export const ChangeLanguageStorePage = lazy(() => import('./ChangeLanguageStorePage'));
export const ChangeLanguageCheckoutPage = lazy(() => import('./ChangeLanguageCheckoutPage'));
export const ProficiencyPage = lazy(() => import('./ProficiencyPage'));
export const TimeSlotsPage = lazy(() => import('./TimeSlotsPage'));
export const BookClassPage = lazy(() => import('./BookClassPage'));
export const CreditsTypeSelectionPage = lazy(() => import('./CreditsTypeSelectionPage'));
export const CongratulationsPage = lazy(() => import('./CongratulationsPage'));
export const LearningGoalsPage = lazy(() => import('./LearningGoalsPage'));
export const LearningGoalSuccessPage = lazy(() => import('./LearningGoalSuccessPage'));
export const LearningFocusAreaPage = lazy(() => import('./LearningFocusAreaPage'));
export const LearningFocusAreaSuccessPage = lazy(() => import('./LearningFocusAreaSuccessPage'));
export const LanguagesYouSpeakPage = lazy(() => import('./LanguagesYouSpeakPage'));
export const LanguagesYouSpeakThanksPage = lazy(() => import('./LanguagesYouSpeakThanksPage'));
